type Data = {
  title: string,
  subtitle: string,
  description: string
};

const data: Data[] = [
  {
    title: "This cider is more than cider",
    subtitle: "It's a drop of refreshing optimism",
    description: "Perfect for sharing in the company of good friends, family and odd acquaintances"
  },
  {
    title: "The delicious Somersby apple cider",
    subtitle: "Was first bottled during an incredible apple harvest in Denmark in the summer of 2008",
    description: "and has since then evolved into a lovely range of fruity flavours"
  },
  {
    title: "Much to our wonder",
    subtitle: "We are now the largest international cider brand in the world",
    description: `
      You can now get a glass of ice cold Somersby if you are visiting a bar in 
      Poland, a festival in Canada, or a beach in Australia - and 47 other
      countries around the globe.
    `
  },
  {
    title: "What makes our cider so special",
    subtitle: "Is the crisp and refreshing taste",
    description: "that comes from our careful and relentless attention to flavour and detail"
  },
  {
    title: "At Somersby, we believe",
    subtitle: "That the perfect glass of cider has the power to bring people together",
    description: "and give out a more positive vibe in the world"
  },
  {
    title: "With the world constantly changing",
    subtitle: "We tend to forget that good things are happening all around us",
    description: "That's why our cider is an open invitation to be more light-hearted, playful and generous"
  },
  {
    title: "All you need to do",
    subtitle: "Is choose to look at life through cider coloured goggles, like we do",
    description: "The way we see it, the glass is always half full of Somersby cider, if you want it to be"
  }
];

export default data;